export default {
    deliver: 'Deliver',
    receive: 'Receive',
    'remaining-materials': 'Remaining Materials',
    'are-you-sure-you-want-to-delete-this-transfer': 'Are you sure you want to delete this transfer?'
}